export default __webpack_public_path__ + "static/Domovea_06-793c1238b552db731d9124da6539de35.webp";